import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaUpload } from 'react-icons/fa';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import SideNavLayout from '../Sidenav/SideNavLayout';
import api from '../api/api';
import { Box, CircularProgress } from '@mui/material';
import ToastMessage from '../utils/muitoast';

const Docshome = () => {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(10); // State to control entries per page
const [currentPage, setCurrentPage] = useState(1);
  const [openToast, setOpenToast] = useState(false); // Toast visibility
  const [toastMessage, setToastMessage] = useState(''); // Message to show in Toast
  const [toastSeverity, setToastSeverity] = useState('error'); 
   const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
 setOpenToast(false);
  };

  // Fetch table data on mount
  useEffect(() => {
    TableDataFetch();
  }, []);

  const TableDataFetch = async () => {
    try {
      const response = await api.get('/v1/documents/my-uploads');
      if (response.status === 200) {
        const formatted = response.data.map((item, index) => ({
          id: item.docid,
          name: item.docname,
          uploadedBy: item.created_by,
          uploadedDate: new Date(item.created_at).toLocaleString(),
          url: item.docpath,
          docname:item.docname,
          docpath:item.docpath
        }));
        setTableData(formatted);
      } else {
        console.error('get data failed for file:');
      }
    } catch (error) {
      console.error('Error get file:', error);
    }
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const uploadedFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('file', file);
      setLoading(true);
      try {
        const response = await api.post('/v1/documents/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 200 || response.status === 201) {
          uploadedFiles.push({
            id: Date.now() + i,
            file,
            name: file.name,
            uploadedBy: 'NTACT Operations',
            uploadedDate: new Date().toLocaleString(),
          });
        } else {
        setToastMessage(`Error uploading file`);
        setToastSeverity('error');
        setOpenToast(true);
        setTimeout(() => {
        setOpenToast(false); // Hide the toast
         }, 2000);
        }
      } catch (error) {
        console.error('Error uploading file:', file.name, error);
      }
    }

    if (uploadedFiles.length) {
      setFiles((prev) => [...prev, ...uploadedFiles]);
      await TableDataFetch(); // ✅ Await for fetch completion
    }

    setLoading(false);
  };

  const filteredFiles = tableData.filter((file) =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

 
  // Paginate the filtered files based on entries per page
const indexOfLastEntry = currentPage * entriesPerPage;
const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
const paginatedFiles = filteredFiles.slice(indexOfFirstEntry, indexOfLastEntry);

const totalPages = Math.ceil(filteredFiles.length / entriesPerPage);

const handleEntriesPerPageChange = (event) => {
  setEntriesPerPage(parseInt(event.target.value, 10));
  setCurrentPage(1); // reset to page 1
};

useEffect(() => {
  setCurrentPage(1); // reset to page 1 on search term change
}, [searchTerm]);

const handlePrintView = async (identifier) => {
  console.log('identifier:', identifier);

  // Extract file extension (e.g., 'pdf', 'png', etc.)
  const extension = identifier.split('.').pop().toLowerCase();
const lastName = '/' + identifier.split('/').pop();


  // Map extensions to MIME types
const mimeTypes = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  bmp: 'image/bmp',
  svg: 'image/svg+xml',
  txt: 'text/plain',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  mp4: 'video/mp4',
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  avi: 'video/x-msvideo',
  mov: 'video/quicktime',
  webm: 'video/webm',
  html: 'text/html',
  json: 'application/json',
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  tar: 'application/x-tar',
  xml: 'application/xml',
};

  const mimeType = mimeTypes[extension] || 'application/octet-stream'; // fallback

  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await api.get(`/v1/documents/view${lastName}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const fileBlob = new Blob([response], { type: mimeType });
    const fileURL = URL.createObjectURL(fileBlob);

    const newWindow = window.open(fileURL, '_blank');
    if (newWindow) {
      newWindow.focus();
    } else {
      console.warn('Pop-up blocked. Please allow pop-ups to view/print the document.');
    }
  } catch (error) {
        setToastMessage(`Something went wrong`);
        setToastSeverity('error');
        setOpenToast(true);
        setTimeout(() => {
        setOpenToast(false); // Hide the toast
        }, 2000);
  }
};



  return (
    <SideNavLayout>
      <div className="w-full p-6 flex flex-col gap-6 font-inter text-[14px]">
        {/* Back Button */}
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-[#145388] text-white px-4 py-1 rounded-md text-sm flex items-center gap-2 w-fit"
        >
          <HomeRoundedIcon style={{ width: 18 }} />
          Back to Home
        </button>
<ToastMessage
        message={toastMessage} 
        severity={toastSeverity} 
        open={openToast} 
        handleClose={handleCloseToast} 
      />
        <div className="flex flex-col gap-10 border-2 border-gray-100 shadow-custom-dark p-4 rounded-[10px]">
          <label className="border-2 border-dashed  border-gray-300 bg-[#FAFAFA] h-[120px] rounded-md flex flex-col justify-center items-center cursor-pointer transition-all">
            <FaUpload className="text-[#9C9C9C] text-2xl mb-2" />
            <span className="text-[#9C9C9C]">click here to upload files</span>
            <input type="file" multiple onChange={handleFileChange} className="hidden" />
          </label>

          {/* Table + Search */}
          <div className="w-full overflow-x-auto border-2 border-dashed  border-gray-300 rounded-md">
            <div className="flex justify-between items-center p-3">
              <span className="text-sm">
                Show
                <select
                  className="mx-1 border border-gray-300 rounded px-1 py-[2px] text-sm"
                  value={entriesPerPage}
                  onChange={handleEntriesPerPageChange}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                entries
              </span>
              <input
                type="text"
                placeholder="Search..."
                className="border border-gray-300 px-2 py-2 rounded w-[30%] text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

        {loading ? (
    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
      <CircularProgress size={50} />
    </Box>
  ) : (
            <div className='m-3 max-h-[200px] overflow-y-auto custom-scrollbar'>
              <table className="w-full text-sm border border-gray-300">
                <thead className="bg-gray-300">
                  <tr>
                    <th className="text-left text-gray-500 px-4 py-2 font-semibold border-r border-gray-100">#</th>
                    <th className="text-left text-gray-500 px-4 py-2 font-semibold border-r border-gray-300">FILE NAME</th>
                    <th className="text-left text-gray-500 px-4 py-2 font-semibold border-r border-gray-300">UPLOAD BY</th>
                    <th className="text-left text-gray-500 px-4 py-2 font-semibold border-r border-gray-300">UPLOADED DATE</th>
                    <th className="text-left text-gray-500 px-4 py-2 font-semibold">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedFiles.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-gray-500">No entries</td>
                    </tr>
                  ) : (
                    paginatedFiles.map((file, index) => (
                      <tr key={file.id} className="border-t border-gray-200 hover:bg-gray-50">
                        <td className="px-4 py-2">{index + 1}</td>
                        <td className="px-4 py-2 text-left">{file.name}</td>
                        <td className="px-4 py-2 text-left">{file.uploadedBy}</td>
                        <td className="px-4 py-2 text-left">{file.uploadedDate}</td>
                        <td className="px-4 py-2 pl-8 text-left">
                     
                          <button
                            onClick={() => handlePrintView(file.docpath)}
                            className="text-[#145388] text-lg cursor-pointer hover:scale-110 transition-transform"
                          >
                            <FaEye />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
              )}
         <div className="flex flex-col sm:flex-row justify-between items-center px-6 py-3 text-sm text-gray-600">
  {/* Left: Entry info */}
  <div className="mb-2 sm:mb-0">
    Showing {filteredFiles.length === 0 ? 0 : `${indexOfFirstEntry + 1} to ${Math.min(indexOfLastEntry, filteredFiles.length)}`} of {filteredFiles.length} entries
  </div>

  {/* Right: Pagination controls */}
  <div className="flex items-center gap-1 flex-wrap">
    <button
      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className={`px-3 py-1 rounded border ${currentPage === 1 ? 'text-gray-400 border-gray-300 cursor-not-allowed' : 'text-[#145388] border-[#145388]'}`}
    >
      Previous
    </button>

    {/* Page numbers */}
    {[...Array(totalPages)].map((_, i) => {
      const page = i + 1;
      return (
        <button
          key={page}
          onClick={() => setCurrentPage(page)}
          className={`px-3 py-1 rounded border transition-all duration-200 ${
            currentPage === page
              ? 'bg-[#145388] text-white border-[#145388]'
              : 'text-[#145388] border-[#145388] hover:bg-[#145388] hover:text-white'
          }`}
        >
          {page}
        </button>
      );
    })}

    <button
      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      className={`px-3 py-1 rounded border ${currentPage === totalPages ? 'text-gray-400 border-gray-300 cursor-not-allowed' : 'text-[#145388] border-[#145388]'}`}
    >
      Next
    </button>
  </div>
         </div>

          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

export default Docshome;
